<template>
  <div>
    <v-sheet class="rounded-0 shadow-none">
      <v-row justify="space-between" align="center">
        <v-col cols="12" class="mt-1 no-space" md="4">
          <v-chip-group
            v-model="selection"
            active-class="light-green darken-3 white--text"
            class="chip-selector float-md-start"
            center-active
            @change="getFilterADP(selection)"
            mandatory
          >
            <v-chip
              v-for="selection in position"
              :key="selection"
              :value="selection"
            >
              {{ selection }}
            </v-chip>
          </v-chip-group>
        </v-col>

        <v-col cols="4" md="2" sm="3" class="p-0 no-space mr-5">
          <v-select
            class="pt-8"
            light
            label="Week"
            :items="weeks"
            item-text="title"
            item-value="value"
            v-model="week"
            dense
            outlined
            @change="fetchADPData"
          >
          </v-select>
        </v-col>
        <v-col cols="4" md="2" sm="3" class="p-0 no-space mr-5">
          <v-select
            class="pt-8"
            light
            label="Season"
            :items="seasons"
            item-text="title"
            item-value="value"
            v-model="season"
            dense
            outlined
            @change="fetchSeasonData"
          >
          </v-select>
        </v-col>
        <v-col v-if="role === 'client'" cols="12" md="2" class="text-center">
          <v-btn
            :loading="ranking_loading"
            :disabled="ranking_loading || !week"
            depressed
            color="green"
            class="white--text mt-2"
            @click="submitPlayers"
          >
            Submit
            <template v-slot:loader>
              <span>Uploading</span>
            </template>
          </v-btn>
        </v-col>
      </v-row>
    </v-sheet>

    <!-- loader -->
    <div v-if="loadingStatus">
      <v-skeleton-loader
        :loading="loadingStatus"
        class="mb-3 mt-4"
        type="list-item-avatar-two-line,table,paragraph"
        elevation="2"
      >
      </v-skeleton-loader>
    </div>

    <!--//? ranking table-->
    <div v-else>
      <div class="mt-5">
        <v-sheet elevation="3" class="mt-0 mt-md-4" v-if="role === 'client'">
          <v-data-table
            v-sortable-data-table
            :headers="headers"
            :items="getPlayers"
            item-key="Name"
            class="elevation-1 adp-table"
            disable-pagination
            disable-items-per-page
            mobile-breakpoint="0"
          >
            <!-- header -->
            <template
              v-for="h in headers"
              v-slot:[`header.${h.value}`]="{ headers }"
            >
              <v-tooltip bottom :key="h.text">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ h.text }}</span>
                </template>
                <span>{{ h.hint }}</span>
              </v-tooltip>
            </template>
            <!-- header -->

            <!-- player name -->
            <template v-slot:item.Name="{ item }">
              <span style="cursor: pointer">{{ item.Name }}</span>
            </template>
            <!-- player name ends -->

            <template v-slot:item.AverageDraftPosition2QB="{ item }">
              <p v-if="!item.AverageDraftPosition2QB">0</p>
              <p v-else>{{ item.AverageDraftPosition2QB }}</p>
            </template>

            <template v-slot:item.AverageDraftPositionDynasty="{ item }">
              <p v-if="!item.AverageDraftPositionDynasty">0</p>
              <p v-else>{{ item.AverageDraftPositionDynasty }}</p>
            </template>
          </v-data-table>
        </v-sheet>

        <!-- for user -->
        <v-sheet elevation="3" class="mt-0 mt-md-4" v-else>
          <v-data-table
            :headers="userHeaders"
            :items="getPlayers"
            item-key="Name"
            class="elevation-1 adp-table"
            mobile-breakpoint="0"
          >
            <!-- header -->
            <template
              v-for="h in headers"
              v-slot:[`header.${h.value}`]="{ headers }"
            >
              <v-tooltip bottom :key="h.text">
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ h.text }}</span>
                </template>
                <span>{{ h.hint }}</span>
              </v-tooltip>
            </template>
            <!-- header -->

            <!-- player name -->
            <template v-slot:item.Name="{ item }">
              <router-link
                class="handle"
                :to="{
                  name: 'PlayerDetail',
                  params: {
                    playerId: item.PlayerID,
                    SportId: item.SportId,
                  },
                }"
                style="text-decoration: none"
              >
                {{ item.Name }}
              </router-link>
            </template>
            <!-- player name ends -->

            <template v-slot:item.AverageDraftPosition2QB="{ item }">
              <p v-if="!item.AverageDraftPosition2QB">0</p>
              <p v-else>{{ item.AverageDraftPosition2QB }}</p>
            </template>

            <template v-slot:item.AverageDraftPositionDynasty="{ item }">
              <p v-if="!item.AverageDraftPositionDynasty">0</p>
              <p v-else>{{ item.AverageDraftPositionDynasty }}</p>
            </template>
          </v-data-table>
        </v-sheet>
      </div>
      <!--//? studs table ends -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { Sortable } from "sortablejs";

export default {
  name: "NflRanking",
  props: ["allSlate", "defaultSport", "defaultOptimizer"],

  components: {},

  data: () => ({
    footerProps: { "items-per-page-options": [25, 35, 70, -1] },
    userId: localStorage.getItem("user"),
    role: localStorage.getItem("role"),
    enabled: true,
    dragging: false,
    loading2: false,
    myArray: [],
    position: ["QB", "RB", "WR", "TE", "K"],
    selection: "QB",
    week: 1,
    weeks: [
      { title: "Week 1", value: 1 },
      { title: "Week 2", value: 2 },
      { title: "Week 3", value: 3 },
      { title: "Week 4", value: 4 },
      { title: "Week 5", value: 5 },
      { title: "Week 6", value: 6 },
      { title: "Week 7", value: 7 },
      { title: "Week 8", value: 8 },
      { title: "Week 9", value: 9 },
      { title: "Week 10", value: 10 },
      { title: "Week 11", value: 11 },
      { title: "Week 12", value: 12 },
      { title: "Week 13", value: 13 },
      { title: "Week 14", value: 14 },
      { title: "Week 15", value: 15 },
      { title: "Week 16", value: 16 },
      { title: "Week 17", value: 17 },
      { title: "Week 18", value: 18 },
    ],
    season: null,
    seasons: [
      { title: "2021", value: 2021 },
      { title: "2022", value: 2022 },
      { title: "2023", value: 2023 },
      { title: "2024", value: 2024 },
      { title: "2025", value: 2025 },
    ],
    headers: [
      { text: "Player", value: "Name", hint: "Name", sortable: false },
      { text: "Team", value: "Team", hint: "Team", sortable: false },
      {
        text: "POS",
        value: "Position",
        hint: "position",
        align: "center",
        sortable: false,
      },
      {
        text: "PA",
        value: "PassingAttempts",
        hint: "Passing Attempts",
        sortable: false,
      },
      {
        text: "PC",
        value: "PassingCompletions",
        hint: "Passing Completions",
        sortable: false,
      },
      {
        text: "PTD",
        value: "PassingTouchdowns",
        hint: "Passing Touchdowns",
        sortable: false,
      },
      {
        text: "PYD",
        value: "PassingYards",
        hint: "Passing Yards",
        sortable: false,
      },
      {
        text: "PYA",
        value: "PassingYardsPerAttempt",
        hint: "PassingYardsPerAttempt",
        sortable: false,
      },
      {
        text: "PR",
        value: "PassingRating",
        hint: "Passing Rating",
        sortable: false,
      },
      {
        text: "RT",
        value: "ReceivingTargets",
        hint: "Receiving Targets",
        sortable: false,
      },
      {
        text: "RTD",
        value: "ReceivingTouchdowns",
        hint: "Receiving Touchdowns",
        sortable: false,
      },
      {
        text: "RY",
        value: "ReceivingYards",
        hint: "Receiving Yards",
      },

      {
        text: "RP",
        value: "ReceptionPercentage",
        hint: "Reception Percentage",
      },
      { text: "RA", value: "RushingAttempts", hint: "Rushing Attempts" },
      { text: "RTD", value: "RushingTouchdowns", hint: "Rushing Touchdowns" },
      { text: "RY", value: "RushingYards", hint: "Rushing Yards" },
      {
        text: "Player ID",
        value: "PlayerID",
        hint: "Player ID",
      },
      {
        text: "Season",
        value: "Season",
        hint: "Season",
      },
      {
        text: "Season Type",
        value: "SeasonType",
        hint: "SeasonType",
      },
      {
        text: "Team ID",
        value: "TeamID",
        hint: "TeamID",
      },
      {
        text: "Sport Id",
        value: "SportId",
        hint: "SportId",
      },
    ],
    userHeaders: [
      { text: "Player", value: "Name", hint: "Name", sortable: false },
      { text: "Team", value: "Team", hint: "Team", sortable: false },
      {
        text: "POS",
        value: "Position",
        hint: "position",
        align: "center",
        sortable: false,
      },
      {
        text: "PA",
        value: "PassingAttempts",
        hint: "Passing Attempts",
        sortable: false,
      },
      {
        text: "PC",
        value: "PassingCompletions",
        hint: "Passing Completions",
        sortable: false,
      },
      {
        text: "PTD",
        value: "PassingTouchdowns",
        hint: "Passing Touchdowns",
        sortable: false,
      },
      {
        text: "PYD",
        value: "PassingYards",
        hint: "Passing Yards",
        sortable: false,
      },
      {
        text: "PYA",
        value: "PassingYardsPerAttempt",
        hint: "PassingYardsPerAttempt",
        sortable: false,
      },
      {
        text: "PR",
        value: "PassingRating",
        hint: "Passing Rating",
        sortable: false,
      },
      {
        text: "RT",
        value: "ReceivingTargets",
        hint: "Receiving Targets",
        sortable: false,
      },
      {
        text: "RTD",
        value: "ReceivingTouchdowns",
        hint: "Receiving Touchdowns",
        sortable: false,
      },
      {
        text: "RY",
        value: "ReceivingYards",
        hint: "Receiving Yards",
      },

      {
        text: "RP",
        value: "ReceptionPercentage",
        hint: "Reception Percentage",
      },
      { text: "RA", value: "RushingAttempts", hint: "Rushing Attempts" },
      { text: "RTD", value: "RushingTouchdowns", hint: "Rushing Touchdowns" },
      { text: "RY", value: "RushingYards", hint: "Rushing Yards" },
    ],
  }),

  directives: {
    sortableDataTable: {
      bind: function (el, binding, vnode) {
        const options = {
          animation: 150,
          ghostClass: "blue-background-class",
          onUpdate(event) {
            vnode.child.$emit("sorted", event.target);
          },
        };
        Sortable.create(el.getElementsByTagName("tbody")[0], options);
      },
    },
  },

  created() {
    this.fetchADPData();
  },

  beforeMount() {
    if (this.userState) {
      this.UpgradeModal = this.userState.plantype === "Free";
    }
  },

  computed: {
    ...mapState("NflModule", ["nfl_adp", "loadingStatus", "ranking_loading"]),
    ...mapGetters("NflModule", ["getFilterADP"]),

    getPlayers() {
      if (this.nfl_adp?.players) {
        return this.getFilterADP(this.selection);
      }
    },
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },

    async fetchADPData() {
      this.season = null;
      await this.$store.dispatch("NflModule/getRankings", { Week: this.week });
    },

    async fetchSeasonData() {
      this.week = null;
      await this.$store.dispatch("NflModule/getSeasonRankings", {
        season: this.season,
      });
    },

    submitPlayers() {
      const tableRows = document.querySelectorAll("tbody tr");
      const dataArray = Array.from(tableRows).map((row) => {
        const cells = row.querySelectorAll("td");
        return {
          Name: cells[0].textContent,
          Team: cells[1].textContent,
          Position: cells[2].textContent,
          // PassingAttempts: cells[3].textContent,
          // PassingCompletions: cells[4].textContent,
          // PassingTouchdowns: cells[4].textContent,
          // PassingYards: cells[5].textContent,
          // PassingYardsPerAttempt: cells[6].textContent,
          // PassingRating: cells[7].textContent,
          // ReceivingTargets: cells[8].textContent,
          // ReceivingTouchdowns: cells[9].textContent,
          // ReceptionPercentage: cells[10].textContent,
          // RushingAttempts: cells[11].textContent,
          // RushingTouchdowns: cells[12].textContent,
          // RushingYards: cells[13].textContent,
          // RushingYardsPerAttempt: cells[14].textContent,
          PlayerID: cells[16].textContent,
          Season: cells[17].textContent,
          SeasonType: cells[18].textContent,
          TeamID: cells[19].textContent,
          SportId: cells[20].textContent,
          // ... and so on for other cells
        };
      });

      console.log("sorted-players", dataArray);
      this.$store
        .dispatch("NflModule/saveRankings", {
          players: dataArray,
          Week: this.week,
        })
        .then(() => {
          this.$store.dispatch("NflModule/getRankings", { Week: this.week });
        });
    },
  },
};
</script>

<style scoped>
.chip-selector >>> .v-chip.v-size--default {
  border-radius: 8px;
}

.chip-selector {
  padding-right: 135px;
}

.v-chip-group >>> .v-slide-group__content {
  padding: 4px 0;
  display: flex;
  justify-content: center;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.v-data-table .v-data-footer {
  display: none !important;
}
</style>
